export const AppLayoutTypes = {
	APP_RIGHT_SIDEBAR_TOGGLE: "APP_RIGHT_SIDEBAR_TOGGLE",
	APP_LEFT_SIDEBAR_TOGGLE: "APP_LEFT_SIDEBAR_TOGGLE",
}
